import assortmentNo from '../resources/no/assortment.json';
import assortmentSe from '../resources/se/assortment.json';
import { AssortmentLanguageResources } from '../types/AssortmentResources';

export const assortmentI18nResources: AssortmentLanguageResources = {
  no: { assortment: assortmentNo },
  se: { assortment: assortmentSe },
};
